// Cover Letter PDF field-length guidance limits.
// Derived empirically from /app/backend/assets/cover_letter_layout.json
// using the actual Roboto/Montserrat font metrics that the PyMuPDF
// renderer uses. Limits represent the soft "starts to feel cramped"
// threshold — the renderer can still gracefully shrink or wrap most
// fields, but past these counts the typography starts to lose its
// designed proportions.
//
// To re-derive: backend/scripts/measure_cover_letter_field_limits.py
// (see iter-39.2 PRD note).
//
// Zone semantics:
//   <= soft  → green   "Looks great"
//   <= max   → amber   "Tight — the PDF may shrink this to fit."
//   >  max   → red     "Will be truncated or shrunk to the minimum."

const COVER_LETTER_FIELD_LIMITS = {
  // Identity fields with renderer auto-shrink.
  full_name: { soft: 22, max: 28, note: "Long names auto-shrink in the PDF." },
  job_title: { soft: 50, max: 70, note: "Wraps to a second line past 30 chars." },

  // Contact column — small text, soft wrap to 2 lines at the floor size.
  phone: { soft: 22, max: 32 },
  email: { soft: 28, max: 38 },
  location: { soft: 24, max: 32 },

  // Header letter fields — single line, no shrink.
  recipient_name: { soft: 28, max: 35 },
  company_name: { soft: 24, max: 32 },

  // Key Strengths — 3 fixed bullet blocks on the printed PDF.
  key_strength_title: { soft: 16, max: 22 },
  key_strength_description: { soft: 75, max: 95 },

  // Letter body — full flow area. Past the max, content will overflow
  // and the renderer will trim trailing paragraphs.
  content: { soft: 1300, max: 1550 },
};

// Returns { count, limit, zone: 'green' | 'amber' | 'red', percent }
// for any field key. Unknown fields return null so the hint hides.
export function evaluateFieldLength(field, value) {
  const cfg = COVER_LETTER_FIELD_LIMITS[field];
  if (!cfg) return null;
  const count = (value || "").length;
  const { soft, max, note } = cfg;
  let zone;
  if (count <= soft) zone = "green";
  else if (count <= max) zone = "amber";
  else zone = "red";
  return {
    count,
    soft,
    max,
    zone,
    percent: max ? Math.round((count / max) * 100) : 0,
    note: note || "",
  };
}

export default COVER_LETTER_FIELD_LIMITS;
